import Button from '@components/Button'
import { formatWithHoursMinutes } from 'shared/time-utilites'

import styles from 'dashboard-subscriptions/components/styles.module.scss'

const ParkerListItemUnoccupied = ({ member, openAssignParkerModal, isDisabled, isDeactivated }) => (
    <div className={styles.productDetails}>
        <span>{member.products[0].ratePlanName}</span>
        <span>
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.plan.name</T>:{' '}
            </span>
            <span>{member.products[0].productName}</span>
        </span>
        <span>
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.start</T>:{' '}
            </span>
            <span>{formatWithHoursMinutes(member.startDate)}</span>
        </span>
        <Button
            onClick={openAssignParkerModal}
            size="small"
            type="button"
            btnStyle="link"
            iconLeft="plus-round"
            className={isDeactivated || isDisabled ? 'mt-3 mb-3 is-disabled' : 'mt-3 mb-3'}
            disabled={isDeactivated || isDisabled}>
            <T>dashboard.subscriptions.products.label.assign</T>
        </Button>
    </div>
)

export default ParkerListItemUnoccupied
